import React from "react";
import {ErrorMessage, Field} from "formik";
import {useTranslation} from "react-i18next";
import InputMask from "react-input-mask";
//local
import {checkField} from "helpers/helper";
import cn from "classnames";

export const FieldInput = ({
  name,
  placeholder,
  label,
  type,
  errorName,
  mask,
  small,
  onChange,
  maskChar,
  className,
  addWrapperClass,
  disabled,
  value,
  as,
  ...props
}) => {
  const {t} = useTranslation();

  return (
    <div
      className={cn(`field${small ? " __small" : ""}`, {
        [addWrapperClass]: !!addWrapperClass,
      })}
    >
      {label && <label className="label">{t(label)}</label>}
      {mask ? (
        <Field name={name}>
          {({field}) => (
            <InputMask
              {...field}
              mask={mask}
              maskChar={maskChar === undefined ? "" : maskChar}
              alwaysShowMask={false}
              disabled={disabled}
              value={value !== undefined ? value : field.value}
              onChange={(event) => {
                field.onChange(event);
                if (onChange) onChange(event);
              }}
              {...props}
            >
              {(inputProps) => (
                <input
                  {...inputProps}
                  name={name}
                  placeholder={t(placeholder)}
                  className={`input ${className || ""}`}
                  type={type || "text"}
                />
              )}
            </InputMask>
          )}
        </Field>
      ) : (
        <Field name={name}>
          {({field}) => {
            const Element = as || "input";
            return (
              <Element
                {...field}
                name={name}
                placeholder={t(placeholder)}
                className={`input ${className || ""}`}
                type={type}
                disabled={disabled}
                value={value !== undefined ? value : field.value}
                onChange={(event) => {
                  field.onChange(event);
                  if (onChange) onChange(event);
                }}
                {...props}
              />
            );
          }}
        </Field>
      )}
      {errorName && (
        <ErrorMessage name={errorName}>
          {(msg) => <p className="form-error">{checkField(msg)}</p>}
        </ErrorMessage>
      )}
    </div>
  );
};
